import { Link, TextField } from '@shopify/polaris';
import { LINK } from '@/constants';
import { useSelector } from 'react-redux';
import { tokenSelector } from '@/redux/features/auth.slice';
import { CustomCard, Stepper } from '@/components';
import { PlayCircleIcon } from '@shopify/polaris-icons';
import { CopyIcon } from '@/icons';
import useTrackingPageUrl from '@/hooks/useTrackingPageUrl';

const EmbedTrackingPage = () => {
  const { shop } = useSelector(tokenSelector);
  const { proxyPath } = useTrackingPageUrl();

  return (
    <CustomCard
      title="Embed tracking page on your store navigation"
      actionGroup={[
        {
          content: 'Watch video',
          variant: 'plain',
          icon: PlayCircleIcon,
          url: 'https://www.youtube.com/watch?v=B5cJ-Az3sTs&list=PL74Buw3DNN_bpLJpGtODRG8yPzBGNufq1&index=2',
        },
      ]}
    >
      <Stepper title="Copy tracking link below">
        <TextField
          label=""
          labelHidden
          value={LINK.CUSTOMER_SHOP(shop, proxyPath)}
          autoComplete="off"
          disabled
          connectedRight={<CopyIcon copiedText={LINK.CUSTOMER_SHOP(shop, proxyPath)} />}
        />
      </Stepper>
      <Stepper
        title={
          <>
            Go to <Link url={LINK.SHOPIFY_MENU(shop)}>Store menus</Link>, choose a menu and add this link as a menu item
          </>
        }
      />
    </CustomCard>
  );
};

export default EmbedTrackingPage;
